import { render, staticRenderFns } from "./ResultsRecentlyOpened.vue?vue&type=template&id=2963518a&scoped=true&"
import script from "./ResultsRecentlyOpened.vue?vue&type=script&lang=js&"
export * from "./ResultsRecentlyOpened.vue?vue&type=script&lang=js&"
import style0 from "./ResultsRecentlyOpened.vue?vue&type=style&index=0&id=2963518a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2963518a",
  null
  
)

export default component.exports